/* /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/reagan.coffee */
(function () {
var slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;

hubspot.define('hubspot.reagan.reagan', ['jQuery', 'q', 'enviro', 'hubspot.reagan.selectors', 'Reagan/constants', 'Reagan/timingUtils'], function($, Q, Env, Selectors, constants, TimingUtils) {
  var BACKOFF_RULE, MAX_INTERVAL, REAGAN_MAJOR_VERSION, Reagan, SLOW_PAGE_START, START_INTERVAL, TIMEOUT, debug, idCounter, sendAlert, startTime, uniqueId;
  MAX_INTERVAL = 250;
  START_INTERVAL = 25;
  TIMEOUT = 60000;
  SLOW_PAGE_START = 45000;
  REAGAN_MAJOR_VERSION = constants.REAGAN_MAJOR_VERSION;
  startTime = TimingUtils.navigationStart();
  BACKOFF_RULE = function(interval, duration) {
    return Math.max(1.5 * interval, duration * 5);
  };
  debug = function() {
    var firstString, rest;
    if (Env.debug('reagan')) {
      firstString = arguments[0], rest = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      return console.log.apply(console, ['[Reagan] ' + firstString].concat(slice.call(rest)));
    }
  };
  idCounter = 0;
  uniqueId = function() {
    return ++idCounter + '';
  };
  sendAlert = function(route, failures) {
    var blockingModules, e, error, exceptions, failure, failureNames, marks, msg, ref, ref1;
    try {
      if (failures.length > 0) {
        exceptions = Q.getUnhandledReasons().map(function(exception) {
          var ref, ref1;
          if (exception) {
            if (typeof exception === 'string') {
              return exception;
            } else {
              return (ref = (ref1 = exception.message) != null ? ref1 : exception.responseText) != null ? ref : exception.statusText;
            }
          }
        });
        marks = ((ref = (ref1 = window.performance) != null ? typeof ref1.getEntriesByType === "function" ? ref1.getEntriesByType('mark') : void 0 : void 0) != null ? ref : []).map(function(entry) {
          var name;
          name = entry.name, startTime = entry.startTime;
          return {
            name: name,
            startTime: startTime
          };
        });
        blockingModules = hubspot.getBlockingModules();
        failureNames = ((function() {
          var i, len, results;
          results = [];
          for (i = 0, len = failures.length; i < len; i++) {
            failure = failures[i];
            results.push(failure.name);
          }
          return results;
        })()).join(',');
        msg = "Reagan failure loading " + failureNames + " on " + route;
        return typeof Raven !== "undefined" && Raven !== null ? typeof Raven.captureMessage === "function" ? Raven.captureMessage(msg, {
          logger: 'Reagan',
          tags: {
            environment: Env.getShort('reagan'),
            deployed: Env.deployed('reagan')
          },
          extra: {
            hash: window.location.hash,
            blockingModules: blockingModules,
            erroredModules: typeof hubspot.getErroredModules === "function" ? hubspot.getErroredModules() : void 0,
            exceptions: exceptions,
            marks: marks,
            time: TimingUtils.millisecondsSinceNavigationStart()
          }
        }) : void 0 : void 0;
      }
    } catch (error) {
      e = error;
      return typeof console !== "undefined" && console !== null ? typeof console.error === "function" ? console.error(e) : void 0 : void 0;
    }
  };
  Reagan = (function() {
    function Reagan(options) {
      var ref, ref1, ref2, ref3;
      if (options == null) {
        options = {};
      }
      this._finishCheck = bind(this._finishCheck, this);
      this._markUserTiming = bind(this._markUserTiming, this);
      this.maxInterval = (ref = options.maxInterval) != null ? ref : MAX_INTERVAL;
      this.startInterval = (ref1 = options.startInterval) != null ? ref1 : START_INTERVAL;
      this.timeout = (ref2 = options.timeout) != null ? ref2 : TIMEOUT;
      this.slowPageStart = (ref3 = options.slowPageStart) != null ? ref3 : SLOW_PAGE_START;
      this.abnormalBehaviorThreshold = this.timeout * 10;
      this.$document = $(document);
      this.checkInProgress = false;
      this.hasFinishedCheck = false;
      this.stats = {
        numChecksStarted: 0,
        numChecksSuccessful: 0,
        numChecksFailed: 0,
        numChecksAborted: 0,
        abortedDurations: []
      };
      if (this.timeout - this.slowPageStart < 1000) {
        throw new Error("The Reagan slowPageStart (" + this.slowPageStart + ") should be at least 1-2 seconds greater than timeout (" + this.timeout + ").");
      }
      if (window.newrelic && window.newrelic.setCustomAttribute) {
        window.newrelic.setCustomAttribute('reaganVersion', REAGAN_MAJOR_VERSION);
      }
      this.startContentReadyTimeout();
      this.testTimeouts = {};
    }

    Reagan.prototype._markUserTiming = function(name, state) {
      var ref;
      return (ref = window.performance) != null ? typeof ref.mark === "function" ? ref.mark("mark_" + name + "_" + state) : void 0 : void 0;
    };

    Reagan.prototype._finishCheck = function(state, payload) {
      var timeBeforeAborted;
      this.checkInProgress = false;
      clearTimeout(this.currentTestWatchdog);
      if (state === 'success') {
        this._markUserTiming('all', 'success');
        this.$document.trigger('Reagan.success');
        this.stats.numChecksSuccessful += 1;
        return this.hasFinishedCheck = true;
      } else if (state === 'failure') {
        this._markUserTiming('all', 'failure');
        this.$document.trigger('Reagan.failure', payload);
        this.stats.numChecksFailed += 1;
        return this.hasFinishedCheck = true;
      } else if (state === 'abort') {
        this.$document.trigger('Reagan.abort', payload);
        this.stats.numChecksAborted += 1;
        timeBeforeAborted = TimingUtils.millisecondsSinceNavigationStart() - this.lastCheckStartedAt;
        return this.stats.abortedDurations.push(timeBeforeAborted);
      } else {
        throw Error("Invalid finish state: " + state);
      }
    };

    Reagan.prototype._hasAnySelectorValuesFor = function(params) {
      var key, value;
      if (params != null) {
        for (key in params) {
          if (!hasProp.call(params, key)) continue;
          value = params[key];
          if (value && value.length > 0) {
            return true;
          }
        }
      }
      return false;
    };

    Reagan.prototype.check = function(route, params, options) {
      var avgAbortDuration, check, checkDuration, checkId, currentTestTimeout, e, error, forDebugStr, giveUpAfter, hasAnyErrorSelectors, hasAnySuccessSelectors, interval, prevInterval, ref, selectors, watchdog, watchdogFailure;
      if (options == null) {
        options = {};
      }
      this.stopTimeoutForCheckNeverBeingCalled();
      try {
        if ((params != null ? params.success : void 0) != null) {
          hasAnySuccessSelectors = this._hasAnySelectorValuesFor(params.success);
          hasAnyErrorSelectors = this._hasAnySelectorValuesFor(params.error);
        } else {
          hasAnySuccessSelectors = this._hasAnySelectorValuesFor(params);
          hasAnyErrorSelectors = false;
        }
        this.checkInProgress = true;
        this.lastCheckStartedAt = TimingUtils.millisecondsSinceNavigationStart();
        this.stats.numChecksStarted += 1;
        if (window.newrelic && window.newrelic.setCustomAttribute) {
          window.newrelic.setCustomAttribute('hasReaganSuccessSelectors', hasAnySuccessSelectors);
          window.newrelic.setCustomAttribute('hasReaganErrorSelectors', hasAnyErrorSelectors);
          window.newrelic.setCustomAttribute('numReaganChecksStarted', this.stats.numChecksStarted);
          window.newrelic.setCustomAttribute('numPreviousReaganChecksAborted', this.stats.numChecksAborted);
          window.newrelic.setCustomAttribute('numPreviousReaganChecksFailed', this.stats.numChecksFailed);
          window.newrelic.setCustomAttribute('numPreviousReaganChecksSuccessful', this.stats.numChecksSuccessful);
          if (((ref = this.stats.abortedDurations) != null ? ref.length : void 0) > 0) {
            avgAbortDuration = this.stats.abortedDurations.reduce((function(_this) {
              return function(total, current) {
                return total + current / _this.stats.abortedDurations.length;
              };
            })(this), 0);
            window.newrelic.setCustomAttribute('avgDurationBeforePreviousReaganAborts', avgAbortDuration);
          }
        }
        if (!params) {
          return;
        }
        this.$document.trigger('Reagan.start', {
          route: route,
          params: params
        });
        if (options.startTimerOnPageLoad == null) {
          options.startTimerOnPageLoad = true;
        }
        if (options.startTimerOnPageLoad) {
          forDebugStr = "(for " + route + " page load)";
        } else if (!this.hasFinishedCheck) {
          forDebugStr = "(for " + route + " load, including some extra route changes)";
        } else {
          forDebugStr = "(for " + route + " route change)";
        }
        selectors = new Selectors(params);
        interval = this.startInterval;
        prevInterval = 0;
        checkDuration = 5;
        currentTestTimeout = null;
        checkId = uniqueId();
        check = (function(_this) {
          return function() {
            var checkStart, failureElementsFound, failures, i, len, name, notFound, numChecked, ref1, ref2, ref3, successElementsFound, value;
            checkStart = TimingUtils.now();
            notFound = selectors.getToCheck();
            numChecked = notFound.length;
            for (i = 0, len = notFound.length; i < len; i++) {
              value = notFound[i];
              name = value.name;
              successElementsFound = $(value.successSelector);
              failureElementsFound = $(value.failureSelector);
              if ((value.successSelector != null) && successElementsFound.length > 0) {
                _this._markUserTiming(name, 'success');
                debug("'" + name + "' check %csucceeded%c " + forDebugStr, "color: green", "color: black", successElementsFound.get(0));
                selectors.found(name, true);
              } else if ((value.failureSelector != null) && failureElementsFound.length > 0) {
                _this._markUserTiming(name, 'failure');
                debug("'" + name + "' check %cfailed%c " + forDebugStr, "color: red", "color: black", failureElementsFound.get(0));
                selectors.found(name, false);
              }
            }
            failures = selectors.getFailed();
            if (failures.length > 0) {
              debug("%cTriggering Reagan errorSelector failure%c (for " + route + ", failed error check = %c" + ((ref1 = failures[0]) != null ? ref1.name : void 0) + "%c)", "font-weight: bold; color: red;", "font-weight: normal; color: black;", "font-weight: bold;", "font-weight: normal;");
              _this.sendReaganPageActionToNewRelic('reaganFinished', {
                status: 'failure',
                failureType: 'errorSelector',
                selector: (ref2 = failures[0]) != null ? ref2.name : void 0
              });
              _this._finishCheck('failure', {
                route: route,
                failures: failures
              });
              sendAlert(route, failures);
            } else if (selectors.isFinished()) {
              debug("%cTriggering Reagan success%c " + forDebugStr, "font-weight: bold; color: green;", "font-weight: normal; color: black;");
              _this.sendReaganPageActionToNewRelic('reaganFinished', {
                status: 'success'
              });
              _this._finishCheck('success');
              if (_this.stats.numChecksSuccessful === 1) {
                if ((ref3 = window.newrelic) != null) {
                  if (typeof ref3.finished === "function") {
                    ref3.finished();
                  }
                }
              }
            } else {
              interval = Math.min(_this.maxInterval, Math.floor(BACKOFF_RULE(interval, checkDuration)));
              currentTestTimeout = setTimeout(check, interval);
              _this.testTimeouts[checkId] = currentTestTimeout;
            }
            prevInterval = interval;
            return checkDuration = TimingUtils.now() - checkStart;
          };
        })(this);
        watchdogFailure = (function(_this) {
          return function() {
            var i, len, name, notFound, value;
            notFound = selectors.getToCheck();
            for (i = 0, len = notFound.length; i < len; i++) {
              value = notFound[i];
              name = value.name;
              debug("'" + name + "' check %ctimed out%c after " + (TIMEOUT / 1000) + "s " + forDebugStr, "color: red", "color: black");
              _this._markUserTiming(name, 'failure.watchdogExpired');
            }
            debug("Triggering %cReagan watchdogExpired failure%c " + forDebugStr, "font-weight: bold; color: red;", "font-weight: normal; color: black;");
            _this.sendReaganPageActionToNewRelic('reaganFinished', {
              status: 'failure',
              failureType: 'watchdogExpired'
            });
            _this._markUserTiming('all', 'failure_watchdog_expired');
            _this._finishCheck('failure', {
              route: route,
              failures: notFound
            });
            return sendAlert(route + ".watchdogExpired", notFound);
          };
        })(this);
        watchdog = function() {
          clearTimeout(currentTestTimeout);
          return watchdogFailure();
        };
        giveUpAfter = this.timeout - TimingUtils.millisecondsSinceNavigationStart();
        if (!options.startTimerOnPageLoad || (giveUpAfter == null) || giveUpAfter > this.timeout) {
          giveUpAfter = this.timeout;
        }
        this.currentTestWatchdog = setTimeout(watchdog, giveUpAfter);
        check();
        return this.testTimeouts[uniqueId()] = this.currentTestWatchdog;
      } catch (error) {
        e = error;
        return typeof console !== "undefined" && console !== null ? typeof console.error === "function" ? console.error(e) : void 0 : void 0;
      }
    };

    Reagan.prototype.startContentReadyTimeout = function() {
      var millisElapsed, timeLeftForSlowStart;
      millisElapsed = TimingUtils.millisecondsSinceNavigationStart();
      timeLeftForSlowStart = Math.max(0, this.slowPageStart - millisElapsed);
      this.alreadySendContentReadyFailure = false;
      return this.contentReadyTimeout = setTimeout((function(_this) {
        return function() {
          _this.sendContentReadyFailure();
          return _this.stop();
        };
      })(this), timeLeftForSlowStart);
    };

    Reagan.prototype.sendContentReadyFailure = function() {
      if (this.alreadySendContentReadyFailure) {
        return;
      }
      this.alreadySendContentReadyFailure = true;
      this.stopTimeoutForCheckNeverBeingCalled();
      debug("Triggering %ccontentReady failure%c after " + (SLOW_PAGE_START / 1000) + "s (for unknown page load)", "font-weight: bold; color: red;", "font-weight: normal; color: black;");
      this.sendReaganPageActionToNewRelic('reaganFinished', {
        status: 'failure',
        failureType: 'contentReady'
      });
      this._markUserTiming('all', 'failure_content_ready');
      return this._finishCheck('failure', {
        route: 'unknown-route'
      });
    };

    Reagan.prototype.sendReaganPageActionToNewRelic = function(actionName, attrs) {
      var MAX_URLS, abortedRequests, e, error, failedRequests, failedRequestsMinus404AndRetries, pendingRequests, ref, ref1, ref2, ref3, succeededRequests, timedOutRequests;
      if (this.hasFinishedCheck) {
        return;
      }
      try {
        if (((ref = window.newrelic) != null ? ref.addPageAction : void 0) != null) {
          if (((ref1 = window.hubspot) != null ? ref1.getHttpRequestStatsByState : void 0) != null) {
            succeededRequests = window.hubspot.getHttpRequestStatsByState('succeeded');
            failedRequests = window.hubspot.getHttpRequestStatsByState('failed');
            abortedRequests = window.hubspot.getHttpRequestStatsByState('aborted');
            pendingRequests = window.hubspot.getHttpRequestStatsByState('pending');
            timedOutRequests = window.hubspot.getHttpRequestStatsByState('timedOut');
            failedRequestsMinus404AndRetries = failedRequests.filter(function(r) {
              return r.status !== 404 && !r.willBeRetried;
            });
            attrs.numSucceededRequests = succeededRequests.length;
            attrs.numAbortedRequests = abortedRequests.length;
            attrs.numPendingRequests = pendingRequests.length;
            attrs.numNotFound = failedRequests.filter(function(r) {
              return r.status === 404;
            }).length;
            attrs.numTimedoutRequests = timedOutRequests.length;
            attrs.numFailedRequestsMinus404AndRetries = failedRequestsMinus404AndRetries.length;
            attrs.numRetriedFailures = failedRequests.filter(function(r) {
              return !!r.willBeRetried;
            }).length;
            MAX_URLS = 10;
            if (failedRequestsMinus404AndRetries.length > 0) {
              attrs.failedRequestUrls = JSON.stringify(failedRequestsMinus404AndRetries.slice(0, MAX_URLS).map(function(r) {
                return r.url;
              }));
            }
            if (timedOutRequests.length > 0) {
              attrs.timedOutRequestUrls = JSON.stringify(timedOutRequests.slice(0, MAX_URLS).map(function(r) {
                return r.url;
              }));
            }
            if (pendingRequests.length > 0) {
              attrs.pendingRequestUrls = JSON.stringify(pendingRequests.slice(0, MAX_URLS).map(function(r) {
                return r.url;
              }));
            }
          }
          if (TimingUtils.millisecondsSinceNavigationStart() < this.abnormalBehaviorThreshold) {
            return (ref2 = window.newrelic) != null ? typeof ref2.addPageAction === "function" ? ref2.addPageAction(actionName, attrs) : void 0 : void 0;
          } else {
            return (ref3 = window.newrelic) != null ? typeof ref3.addPageAction === "function" ? ref3.addPageAction('reaganFinishedAbnormally', attrs) : void 0 : void 0;
          }
        }
      } catch (error) {
        e = error;
        return console.warn('Error trying to send XHR stats to New relic', e);
      }
    };

    Reagan.prototype.stopTimeoutForCheckNeverBeingCalled = function() {
      return clearTimeout(this.contentReadyTimeout);
    };

    Reagan.prototype.stop = function() {
      var id, ref, timeout;
      this.stopTimeoutForCheckNeverBeingCalled();
      ref = this.testTimeouts;
      for (id in ref) {
        timeout = ref[id];
        clearTimeout(timeout);
      }
      if (this.checkInProgress) {
        this._finishCheck('abort');
      }
      return this.testTimeouts = {};
    };

    return Reagan;

  })();
  Reagan.prototype.elect = Reagan.prototype.check;
  Reagan.prototype.impeach = Reagan.prototype.stop;
  return Reagan;
});
}());




//////////////////
// WEBPACK FOOTER
// ../~/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!../~/bender-webpack/lib/no-parse-loader.js!../~/bender-webpack/lib/sporks/loader.js!/usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/reagan.coffee
// module id = 594
// module chunks = 